import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AutomationFlowsGateway from './AutomationFlowsGateway.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/automation'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'automation_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'automation_list',
          component: AutomationFlowsGateway,
          meta: {
            featureFlag: FEATURE_FLAGS.AUTOMATIONS,
            // flow_manage: the flows tab is the only door to flows
            permissions: ['administrator', 'automation_manage', 'flow_manage'],
          },
        },
      ],
    },
  ],
};
